module.exports = __webpack_public_path__ + "static/media/cakeBackground.634f0997.jpeg";